import { FASTElement as l, attr as r } from "@microsoft/fast-element";
import { toastStyles as d } from "./toast.styles.js";
import { toastTemplate as f } from "./toast.template.js";
import { NumberStringConverter as h } from "../../common/converters/number-string-converter.js";
var v = Object.defineProperty, s = (a, o, m, u) => {
  for (var t = void 0, i = a.length - 1, p; i >= 0; i--)
    (p = a[i]) && (t = p(o, m, t) || t);
  return t && v(o, m, t), t;
};
const n = class n extends l {
  constructor() {
    super(...arguments), this.variant = "info", this.show = !1, this.dismissible = !1, this.duration = 0;
  }
  dismiss() {
    var o;
    this.style.display = "none", (o = this.parentElement) == null || o.removeChild(this);
  }
};
n.definition = {
  name: "toast",
  template: f,
  styles: d
};
let e = n;
s([
  r
], e.prototype, "variant");
s([
  r({ mode: "boolean" })
], e.prototype, "show");
s([
  r({ mode: "boolean" })
], e.prototype, "dismissible");
s([
  r({ converter: h })
], e.prototype, "duration");
export {
  e as Toast
};
